// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDBT3B53E8UZpDgnfveg7vD3Wt28txJ9Pc",
  authDomain: "finnovate99.firebaseapp.com",
  databaseURL: "https://finnovate99.firebaseio.com",
  projectId: "finnovate99",
  storageBucket: "finnovate99.appspot.com",
  messagingSenderId: "428244738275",
  appId: "1:428244738275:web:e5bca9cae5246714cee5d6",
  measurementId: "G-5PQE97EKCS"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
export default firebase